import { Columns3Icon } from 'lucide-react';
import { MRT_ShowHideColumnsMenu as ShadcnShowHideColumnsMenu } from '@talentmesh/table';
import React from 'react';
import { useCandidatesTableContext } from '../../Contexts/CandidatesTableContext/CandidatesTableContext';
import {
    Button,
    DropdownMenuContent,
    TooltipContent,
    DropdownMenuTrigger,
    DropdownMenu,
    Tooltip,
    TooltipTrigger,
} from '@/Components/shadcn';

const EditColumnsButton = () => {
    const table = useCandidatesTableContext();

    return (
        <DropdownMenu>
            <Tooltip>
                <TooltipTrigger asChild>
                    <DropdownMenuTrigger asChild>
                        <Button
                            variant="ghost"
                            size="icon"
                            type="button"
                            data-cy="editColumnButton"
                            aria-label="Edit columns"
                        >
                            <Columns3Icon />
                        </Button>
                    </DropdownMenuTrigger>
                </TooltipTrigger>
                <TooltipContent side="bottom">Show/Hide Columns</TooltipContent>
            </Tooltip>
            <DropdownMenuContent
                align="start"
                className="overflow-y-auto"
                onCloseAutoFocus={(e) => e.preventDefault()}
                side="bottom"
                data-cy="editColumnMenu"
            >
                <ShadcnShowHideColumnsMenu table={table} />
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default EditColumnsButton;
